import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import PricingBanner from "@/components/site/PricingBanner";
import Services from "@/components/site/Services";
import WhyDazTec from "@/components/site/WhyDazTec";
import ServiceArea from "@/components/site/ServiceArea";
import EnquiryForm from "@/components/site/EnquiryForm";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="grain-bg">
      <Header />
      <Hero />
      <PricingBanner />
      <Services />
      <WhyDazTec />
      <ServiceArea />
      <EnquiryForm />
      <FAQ />
      <Footer />
    </main>
  );
}
